import { render, staticRenderFns } from "./HtSaveButton.vue?vue&type=template&id=15fd3f7b&"
import script from "./HtSaveButton.vue?vue&type=script&lang=js&"
export * from "./HtSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports